import { render, staticRenderFns } from "./page-head.vue?vue&type=template&id=1ea93379&"
import script from "./page-head.vue?vue&type=script&lang=js&"
export * from "./page-head.vue?vue&type=script&lang=js&"
import style0 from "./page-head.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea93379')) {
      api.createRecord('1ea93379', component.options)
    } else {
      api.reload('1ea93379', component.options)
    }
    module.hot.accept("./page-head.vue?vue&type=template&id=1ea93379&", function () {
      api.rerender('1ea93379', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/common/page-head.vue"
export default component.exports